<div class="color-bar" *ngIf="data" [style.width]="chartArea.width+'px'" [style.margin-left]="(chartArea.left)+'px'">
    <div class="suninfo-container" *ngIf="sunInfo">
        <div class="element-container">
            <div class="sunset period" [style.width]="sunsetWidth+'px'" [style.left]="sunsetPositionOffset+'px'">
                <div class="inner" [matTooltip]="tooltipText('sunset_period')" [matTooltipPosition]="'above'"></div>
            </div>
            <div class="sunset current" [style.left]="sunsetCurrentOffset+'px'">
                <div class="d-flex icon-container" [matTooltip]="tooltipText('sunset_current')" [matTooltipPosition]="'above'">
                    <i class="material-icons sun-icon">bedtime</i>
                </div>
            </div>
        </div>
        <div class="element-container">
            <div class="sunrise period"  [style.width]="sunriseWidth+'px'" [style.left]="sunrisePositionOffset+'px'">
                <div class="inner" [matTooltip]="tooltipText('sunrise_period')" [matTooltipPosition]="'above'"></div>
            </div>
            <div class="sunrise current" [style.left]="sunriseCurrentOffset+'px'">
                <div class="d-flex icon-container" [matTooltip]="tooltipText('sunrise_current')" [matTooltipPosition]="'above'">
                    <i class="material-icons sun-icon">wb_sunny</i>
                </div>
            </div>
        </div>
    </div>
    <div class="color-bar-inner d-flex" [style.width]="chartArea.width+'px'">
        <div class="color-point" *ngFor="let point of dataPointList" [style.background-color]="point.colorHex" [style.width]="point.width+'%'"></div>
    </div>
</div>
